import { store } from "../redux/store";
export var calculatePayments = function (selectedSum, selectedPeriod) {
    var selectedTariff = store.getState().selectedTariff;
    if (!selectedTariff.tariff) {
        return null;
    }
    var percentArray = selectedTariff.tariff.periodPercent;
    var numberOfPayments = percentArray.length;
    if (numberOfPayments === 0 || numberOfPayments === 1) {
        var sumPlusPrc = selectedSum + (selectedSum * (selectedTariff.tariff.percent / 100) * selectedPeriod);
        return {
            amount: 1,
            payment: sumPlusPrc,
        };
    }
    else {
        var payment = selectedSum / numberOfPayments;
        if (percentArray[0] !== percentArray[numberOfPayments - 1]) {
            payment = calcLongPeriodLoanPay(percentArray, selectedSum, selectedTariff.tariff.periodPay);
        }
        else {
            payment = calcLongLoanPay(percentArray[0], selectedSum, selectedTariff.tariff.periodPay, numberOfPayments);
        }
        return {
            amount: numberOfPayments,
            payment: payment
        };
    }
};
/**
 * Формула расчета аннуитетного платежа  с переменной ставкой
 * @param Array<number> table Массив процентов по периодам
 * @param number sum Сумма
 * @param number period Период в днях
 * @return number
 */
var calcLongPeriodLoanPay = function (table, currentSum, period) {
    var od = currentSum;
    // Получаем пробную сумму платежа, с которой начнем приближение
    var pay = currentSum / table.length;
    // Допустимая погрешность
    var accuracy = 0.01;
    // Максимально кол-во итераци
    var count = 100;
    var diff = pay;
    var direction = '+';
    while (Math.abs(od) > accuracy && count > 0) {
        od = currentSum;
        od = table.reduce(function (odItem, item) {
            var prcPay = odItem * period * item * 0.01; // платеж по процентам
            var odPay = pay - prcPay; // платеж по од
            return odItem - odPay; // остаток од
        }, od);
        if (od > 0) {
            if (direction === '-') {
                diff /= 2;
            }
            pay += diff;
            direction = '+';
        }
        else {
            if (direction === '+') {
                diff /= 2;
            }
            pay -= diff;
            direction = '-';
        }
        count--;
    }
    return Math.round(pay);
};
/**
 * Формула расчета аннуитетного платежа  с постоянной ставкой
 * @param number percent Процент
 * @param number sum Сумма
 * @param number period Период в днях
 * @param number countPeriod Кол-во периодов
 * @return number
 */
var calcLongLoanPay = function (percent, currentSum, period, countPeriod) {
    var numerator = percent * period * 0.01;
    numerator *= Math.pow(1 + percent * period * 0.01, countPeriod);
    var delimeter = Math.pow(1 + percent * period * 0.01, countPeriod) - 1;
    return Math.round((currentSum * (numerator / delimeter)));
};
